import { inViewFade, inViewFadeUp } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { imageCoverContainer } from '@helpers/image';
import { Device, from } from '@helpers/media';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import SimpleImage from '@stories/Components/SimpleImage/SimpleImage';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --bgColor: ${brand.grey.grey6};
  --fgColor: ${brand.white};

  position: relative;
  background: var(--bgColor);
  color: var(--fgColor);
  padding: 52px 0;

  @media ${from(Device.TabletLarge)} {
    padding: 96px 0;
  }

  @media ${from(Device.DesktopSmall)} {
    padding: 190px 0;
  }
`;
const ImageWrapper = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  height: 100%;
  width: 100%;
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: rgba(0, 0, 0, var(--tintAmount));
    width: 100%;
  }

  ${inViewFade({ delay: 0, duration: 0.6 })};
`;
const Image = styled(SimpleImage) `
  ${imageCoverContainer(true)}
`;
const ContentWrapper = styled.div `
  position: relative;
  max-width: 713px;
  width: 100%;
  z-index: 2;
`;
const Title = styled.h2 `
  display: block;
  ${fonts.helvetica.bold};
  font-size: 18px;
  line-height: 26px;
  letter-spacing: -0.01em;
  margin-bottom: 18px;

  @media ${from(Device.TabletSmall)} {
    font-size: 33px;
    line-height: 43px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 35px;
    line-height: 45px;
    margin-bottom: 32px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 40px;
    line-height: 52px;
  }

  ${inViewFadeUp({ delay: 0.15, duration: 0.3 })};
`;
const Subtitle = styled.small `
  display: block;
  ${fonts.helvetica.regular};
  font-size: 14px;
  line-height: 22px;
  letter-spacing: -0.01em;
  margin-bottom: 18px;

  @media ${from(Device.TabletSmall)} {
    font-size: 23px;
    line-height: 33px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 25px;
    line-height: 35px;
    margin-bottom: 20px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 28px;
    line-height: 40px;
  }

  ${inViewFadeUp({ delay: 0, duration: 0.3 })};
`;
const CtaWrapper = styled.div `
  ${inViewFadeUp({ delay: 0.3, duration: 0.3 })};
`;
const NextArticleSectionStyles = {
    Container,
    ContentWrapper,
    CtaWrapper,
    Image,
    ImageWrapper,
    Subtitle,
    Title,
};
export default NextArticleSectionStyles;
